import React from 'react'
import Image from '../Image'
import getImageSrc from './helper/getImageSrc'

export default function BotImageLoader({
  src,
  alt = '',
  width = null,
  height = null,
  layout = null,
  fit = null,
  onClick = null,
  style = null,
  cloudinaryParams,
  overrideCloudinary = false,
}) {
  if (!src) return null

  const imgSrc = getImageSrc(src, cloudinaryParams, overrideCloudinary)

  return (
    <Image
      src={imgSrc}
      alt={alt}
      width={width}
      height={height}
      layout={layout}
      fit={fit}
      onClick={onClick}
      style={style}
      crossOrigin="anonymous"
    />
  )
}
